import axios from "axios";
import { Response } from "@/shared/models/Response";
import { InitialData } from "../models/InitialData";
import { Role } from "../models/Role";
import { RoleInfo } from "../models/RoleInfo";
import { CrudChartData } from "@/shared/models/CrudChartData";
import { QuerySearchRole } from "../models/QuerySearchRole";

export class RolesService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_USERS_API}/roles`;
  }

  async getInitialData(): Promise<Response<InitialData>> {
    return (await axios.get(`${this.baseUrl}/initial`)).data;
  }

  async createRole(role: Role): Promise<Response<string | void>> {
    return (await axios.post(`${this.baseUrl}`, role)).data;
  }

  async getRoles(options?: {
    name?: string | null;
    state?: string | null;
    docref?: string | null;
  }): Promise<Response<RoleInfo[] | void>> {
    return (
      await axios.get(`${this.baseUrl}`, {
        params: {
          name: options?.name,
          state: options?.state,
          docref: options?.docref
        }
      })
    ).data;
  }

  async getRoleData(id: string): Promise<Response<Role | void>> {
    return (await axios.get(`${this.baseUrl}/data/${id}`)).data;
  }

  async updateRole(role: Role, id: string): Promise<Response<string | void>> {
    return (await axios.put(`${this.baseUrl}/${id}`, role)).data;
  }

  async deleteRole(id: string): Promise<Response<string | void>> {
    return (await axios.delete(`${this.baseUrl}/${id}`)).data;
  }

  async getAllActiveRoles(): Promise<Response<RoleInfo[] | void>> {
    return (await axios.get(`${this.baseUrl}/get-all-active-roles`)).data;
  }

  async getRolesByFiltersArrays(
    query: QuerySearchRole
  ): Promise<Response<CrudChartData | void>> {
    return (
      await axios.get(`${this.baseUrl}/get-by-filters-arrays`, {
        params: query
      })
    ).data;
  }

  async updateStateRoleById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async checkIfExistByName(name: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;

    const params = {
      params: {
        nameRole: name
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }
}
